/**
 * SEC-11: Execute runs one SELECT/FIND statement only — no DML
 * (DELETE/UPDATE/INSERT/UPSERT/MERGE) and no stacked statements. Mirrors
 * `read_only_refusal` in graph-service `/soql/execute`, which refuses the same
 * queries with HTTP 400; checking here first keeps a hand-edited DELETE from
 * reaching the server or the self-correction agent at all.
 *
 * Quoted literals are blanked first so `Name = 'a;b'` is not read as two
 * statements.
 */
const STRING_LITERAL = /'(?:\\.|[^'\\])*'/g;
const LEADING_KEYWORD = /^\s*([A-Za-z]+)/;
const READ_ONLY_KEYWORDS = new Set(["SELECT", "FIND"]);

/** Why `soql` may not run, or null when it is a single read-only statement. */
export function readOnlyRefusal(soql: string): string | null {
  const unquoted = (soql ?? "").replace(STRING_LITERAL, "''");
  const match = LEADING_KEYWORD.exec(unquoted);
  if (!match) {
    return "Only a single SELECT query can be run here. The query is empty.";
  }
  const keyword = match[1].toUpperCase();
  if (!READ_ONLY_KEYWORDS.has(keyword)) {
    return `Only a single SELECT query can be run here. This query starts with '${keyword}', which is not allowed.`;
  }
  if (unquoted.includes(";")) {
    return "Only a single SELECT query can be run here. Remove the ';' and run one query at a time.";
  }
  return null;
}
